import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/app'
import './faro-config' // Initialize Faro business tracking

// Global error handler for unhandled errors
window.addEventListener('error', (event) => {
  if (window.faroTracker) {
    window.faroTracker.trackError(event.error, {
      error_type: 'unhandled_error',
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno
    });
  }
});

// Global unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  if (window.faroTracker) {
    window.faroTracker.trackError(new Error(event.reason), {
      error_type: 'unhandled_promise_rejection',
      reason: event.reason
    });
  }
});

ReactDOM.render(<App />, document.getElementById('root'))
